/* import __COLOCATED_TEMPLATE__ from './median-first-response-time.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import Component from '@glimmer/component';
import { units } from 'embercom/lib/reporting/flexible/formatters';
import {
  DIRECT_TO_HUMAN_MEDIAN_FIRST_RESPONSE_TIME,
  SELF_SERVE_FAILED_MEDIAN_FIRST_RESPONSE_TIME,
} from 'embercom/lib/reporting/csf-queries';
import { getTimeConfig } from 'embercom/lib/reporting/csf-query-helper';
import { buildDataConfigWithComparisons } from '../../../../lib/reporting/comparison-data-config';
import { improvementDirections } from 'embercom/components/reporting/element/summary-comparison';

const SELF_SERVE_FAILED_MEDIAN_RESPONSE_TIME = 'self-serve-failed-median-response-time';
const DIRECT_TO_HUMAN_SUPPORT_MEDIAN_RESPONSE_TIME = 'direct-to-human-support-median-response-time';

export default class MedianFirstResponseTimeComponent extends Component {
  get viewConfig() {
    return {
      formatUnit: { unit: units.minute },
      counter: {
        [SELF_SERVE_FAILED_MEDIAN_RESPONSE_TIME]: {
          improvementDirection: improvementDirections.DECREASING,
        },
        [DIRECT_TO_HUMAN_SUPPORT_MEDIAN_RESPONSE_TIME]: {
          improvementDirection: improvementDirections.DECREASING,
        },
        [`${SELF_SERVE_FAILED_MEDIAN_RESPONSE_TIME}-in-office-hours`]: {
          improvementDirection: improvementDirections.DECREASING,
        },
        [`${DIRECT_TO_HUMAN_SUPPORT_MEDIAN_RESPONSE_TIME}-in-office-hours`]: {
          improvementDirection: improvementDirections.DECREASING,
        },
      },
    };
  }

  get dataConfig() {
    return buildDataConfigWithComparisons(
      {
        series: [
          {
            name: this.queryName,
            ...this.query(this.args.settings?.excludeOooHours),
            time: getTimeConfig({ range: this.args.range }),
          },
        ],
      },
      this.args.range,
    );
  }

  nameInOfficeHours(name) {
    if (this.args.settings?.excludeOooHours) {
      name = `${name}-in-office-hours`;
    }
    return name;
  }

  get queryName() {
    return this.nameInOfficeHours(
      this.args.isSelfServeFailed
        ? SELF_SERVE_FAILED_MEDIAN_RESPONSE_TIME
        : DIRECT_TO_HUMAN_SUPPORT_MEDIAN_RESPONSE_TIME,
    );
  }

  get query() {
    return this.args.isSelfServeFailed
      ? SELF_SERVE_FAILED_MEDIAN_FIRST_RESPONSE_TIME
      : DIRECT_TO_HUMAN_MEDIAN_FIRST_RESPONSE_TIME;
  }

  get reportingExcludeOooHours() {
    return this.args.settings?.excludeOooHours;
  }
}
